import { StyledCalendar } from './StyledCalendar';

export default StyledCalendar;
